import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { CreateRecurringMeetingInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const CreateRecurringMeetingMutation = graphql(`
  mutation CreateRecurringMeeting($input: CreateRecurringMeetingInput!) {
    createRecurringMeeting(input: $input) {
      id
      __typename
      cadence
      startDate
      until
      scheduledStartTime
      scheduledEndTime
      client {
        id
        legacyId
        name
        externalReference
        __typename
      }
    }
  }
`);

export function useCreateRecurringMeeting() {
  const [result, createRecurringMeetingMutation] = useMutation(CreateRecurringMeetingMutation);
  const [error, setError] = useState<Error | null>(null);

  const createRecurringMeeting = useCallback(
    async (input: CreateRecurringMeetingInput) => {
      try {
        const response = await createRecurringMeetingMutation({ input });

        if (response.error) {
          throw response.error;
        }

        return response.data?.createRecurringMeeting;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [createRecurringMeetingMutation],
  );

  return { createRecurringMeeting, result, error };
}
